/**
 * Compliance Badge Component
 * Displays compliance status with appropriate color coding
 */

import { Badge } from '../ui/badge';

interface ComplianceBadgeProps {
  isCompliant: boolean;
  isExpiringSoon?: boolean;
  label?: string;
}

export function ComplianceBadge({ isCompliant, isExpiringSoon = false, label }: ComplianceBadgeProps) {
  if (isCompliant && !isExpiringSoon) {
    return (
      <Badge variant="success" className="whitespace-nowrap">
        {label || 'Compliant'}
      </Badge>
    );
  }

  if (isCompliant && isExpiringSoon) {
    return (
      <Badge variant="warning" className="whitespace-nowrap">
        {label || 'Expiring Soon'}
      </Badge>
    );
  }

  return (
    <Badge variant="destructive" className="whitespace-nowrap">
      {label || 'Expired'}
    </Badge>
  );
}
